<template>
<v-list-item three-line v-if="uid">
    <v-btn icon @click="goBack">
        <v-icon>mdi-chevron-left</v-icon>
    </v-btn>
    <v-list-item-avatar tile size="80" color="grey" class="ml-5" v-if="this.userInfo.avatar" >
        <img :src="this.userInfo.avatar"/>
    </v-list-item-avatar>
    <v-avatar v-else color="info" size="80" class="mr-2">
        <v-icon dark x-large> mdi-account-circle </v-icon>
    </v-avatar>
    <v-list-item-content class="ml-5">
        <v-list-item-title class="text-h5 mb-1">
            {{this.userInfo.name}}
        </v-list-item-title>
        <div>
            อายุ: {{ this.userInfo.age }} ปี 
        </div>
        <div>
            เพศ: {{ this.gender[this.userInfo.gender] }}
        </div>
    </v-list-item-content>
</v-list-item>
</template>

<script>
import getUserInfoByUserId from '../data/getUserInfoByUserId';

export default {
    data() {
        return {
            gender: {
                female: "หญิง",
                male: "ชาย"
            },
            userInfo: []
        };
    },
    created() {
        (async () => {
            this.userInfo = await getUserInfoByUserId(this.uid);
        })();
    },
    computed: {
        uid() {
            return this.$attrs.uid;
        }
    },
    methods: {
        goBack() {
            if( this.$route.params.mod == 'member-list' ){
                this.$router.push(`/program/member-list`);
            }
            else{
                this.$router.go(-1);
                // this.$router.push(`/program/program-list/view/${this.userInfo.currentProgram}`);
            }
        }
    }
};
</script>
